import { dimensions, SvgIconProps } from "./SvgIcon";
import { theme } from "antd";

export const JiraIcon = (props: SvgIconProps) => {
  const { token } = theme.useToken();
  const { width, height } = dimensions(props);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8317 6.60824L7.6031 0.583949L6.99934 0L2.31069 4.53485L0.166974 6.60824C-0.0565328 6.82468 -0.0565328 7.17532 0.166974 7.39176L4.45058 11.5348L6.99934 14L11.688 9.46515L11.7606 9.39493L13.8317 7.39176C14.0552 7.17532 14.0552 6.82468 13.8317 6.60824ZM6.99934 9.06969L4.85945 7L6.99934 4.93031L9.13924 7L6.99934 9.06969Z"
        fill={token.colorPrimary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99963 4.93125C5.59859 3.57601 5.59176 1.38095 6.98435 0.0175781L2.30142 4.54503L4.85019 7.01019L6.99963 4.93125Z"
        fill="url(#paint0_linear_6333_23507)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.14497 6.99414L6.99934 9.06938C7.67558 9.72304 8.05552 10.6098 8.05552 11.5345C8.05552 12.4592 7.67558 13.346 6.99934 13.9997L11.6937 9.45929L9.14497 6.99414Z"
        fill="url(#paint1_linear_6333_23507)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6333_23507"
          x1="6.61751"
          y1="2.83754"
          x2="3.04789"
          y2="4.39609"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor={token.colorPrimaryHover} />
          <stop offset="1" stopColor={token.colorPrimary} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6333_23507"
          x1="7.40822"
          y1="11.1391"
          x2="10.9714"
          y2="9.59158"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor={token.colorPrimaryHover} />
          <stop offset="1" stopColor={token.colorPrimary} />
        </linearGradient>
      </defs>
    </svg>
  );
};
